import { render, staticRenderFns } from "./DadosCasamentoCollapse.vue?vue&type=template&id=1430f48c&scoped=true&"
import script from "./DadosCasamentoCollapse.vue?vue&type=script&lang=js&"
export * from "./DadosCasamentoCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1430f48c",
  null
  
)

export default component.exports